/**
 * Goods receipt line — org/{orgId}/goods-receipt/{goodsReceiptId}/item
 *
 * ProductRef copied from the PO line (partial variant). Size distribution (if any)
 * lives on {@link GoodsReceiptItemBreakdown}.
 */
export const GOODS_RECEIPT_ITEM = 'GoodsReceiptItem';
//# sourceMappingURL=goods-receipt-item.js.map